<template>
  <div>
    <div class="title">
      <span class="i"></span>未结款订单
      (
      <div style="display: inline-block" v-if="searchCondition.time_type!=='all'">
        <span v-if="searchCondition.year">{{ searchCondition.year }}年</span>
        <span v-if="searchCondition.month">{{ searchCondition.month }}月</span>
        <el-tooltip class="item" effect="dark" content="以“下单时间”为维度" placement="top-start">
          <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
        </el-tooltip>
      </div>
      <div style="display: inline-block" v-else>
        全部
      </div>
      )
    </div>
    <el-form :model="searchCondition" label-width="70px" class="forms" size="mini" inline>
      <el-form-item label="公司名称">
        <el-input
            class="el-input-m"
            v-model="searchCondition.name"
            placeholder="请输入公司名称"
            @change="search" clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="执行状态">
        <el-select v-model="searchCondition.bool_exec" placeholder="请选择执行状态"
                   @change="search">
          <el-option label="全部" :value="2"></el-option>
          <el-option label="未执行" :value="0"></el-option>
          <el-option label="已执行" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
            type="primary"
            @click="initList()"
            icon="el-icon-search"
        >查询
        </el-button>
        <el-button type="text" @click="reset" style="margin-left:30px;">重置
        </el-button>
      </el-form-item>
    </el-form>
    <div class="default-table" style="width: 100%">
      <ape-table
          :ref="tableRef"
          :data="dataList"
          :paging-data="pagingData"
          :columns="[]"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          @changeTableSort="changeTableSort"
          show-summary
          highlight-current-row
          style="width: 100%"
          max-height="600px"
      >
        <el-table-column label="序号" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公司名称" prop="name" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.customer ? scope.row.customer.name : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售" prop="sale" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.sale ? scope.row.sale.name : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单总金额" prop="payment_account" min-width="100">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.payment_account,2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已回款金额" prop="sum_amount" min-width="100">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.sum_amount,2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="需回款金额" prop="remain_account" min-width="100">
          <template slot-scope="scope">
            <span>{{ gFunc.numberFormat(scope.row.remain_account,2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            key="联系人"
            label="联系人"
            align="center"
            :min-width="80"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="showContacts(scope.row.customer_id,scope.row.sale_id,scope.row.customer.name)"
            >查看联系人</el-link>
          </template>
        </el-table-column>
        <el-table-column
            key="操作项"
            label="操作项"
            align="center"
            :min-width="80"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="exOrderDetail(scope.row.id)">查看详情</el-link>
          </template>
        </el-table-column>
      </ape-table>
    </div>
    <el-dialog :title="`${contactCustomer}-联系人列表`" :visible.sync="dialogCustomerContactVisible">
      <el-table
          class="data-table"
          :data="contactCustomerData"
          max-height="400"
          border
          :row-class-name="rowClassName"
          style="width: 100%">
        <el-table-column prop="index" label="序号" width="50" align="center" />
        <el-table-column prop="contact_name" label="姓名" width="120" align="center" />
        <el-table-column prop="contact_position" label="职位" width="80"
                         :show-overflow-tooltip="true" align="center" />
        <el-table-column prop="contact_phone" label="联系电话" width="120"
                         :show-overflow-tooltip="true" align="center" />
        <el-table-column prop="tax_id" label="省市区" width="160"
                         :show-overflow-tooltip="true" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact_province + scope.row.contact_city + scope.row.contact_area }}
          </template>
        </el-table-column>
        <el-table-column prop="contact_address" label="详细地址" align="right" />
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import {getNonPayData} from "@/api/home";
import {getCustomerContacts} from "@/api/customers";

export default {
  name: "UnsettledFundOrderTable",
  components: {ApeTable},
  props: {
    year: [Number, String],
    month: [Number, String],
    timeType: {
      type: String,
      default() {
        return 'not_all'
      }
    },
  },
  data() {
    return {
      loadingStatus: false,
      dataList: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 8
      },
      orderSortObj: {},//默认排序规则
      searchCondition: {
        year: null,
        month: null,
        name: null,
        time_type: 'not_all',
        start_time: 0,
        end_time: 0,
        bool_exec: 2
      },
      tableRef: 'refUnsettledFundOrderTable',
      dialogCustomerContactVisible: false,
      recordForm: {
        follow_timestamp: "",
        record_content: "",
        customer_id: ""
      },
      contactCustomer: '',
      contactCustomerData:[],
      followRecord: [],
    }
  },
  watch: {
    timeType() {
      this.searchCondition.time_type = this.timeType
      this.search()
    },
    year() {
      this.searchCondition.year = this.year
      this.search()
    },
    month() {
      this.searchCondition.month = this.month
      this.search()
    }
  },
  created() {
    this.searchCondition.year = this.year
    this.searchCondition.month = this.month
    this.searchCondition.time_type = this.timeType
    this.search()
  },
  methods: {
    rowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1
      if ((rowIndex % 2) === 1) {
        return 'table-row commonTable-row'
      } else {
        return 'table-row success-row'
      }
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 1) {
          sums[index] = '合计:'
          return
        }
        if (['order_count', 'sum_money'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          switch (column.property) {
            case 'order_count':
              sums[index] = this.gFunc.numberFormat(sums[index])
              break;
            case 'sum_money':
              sums[index] = this.gFunc.numberFormat(sums[index])
              break;
            default:
              break
          }
        }
      })

      return sums
    },
    changeTableSort({prop, order}) {
      this.orderSortObj = {order: order, prop: prop}
      // let orderSort = {}
      // if (order) {
      //   orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      // }
      //
      // this.orderSort = orderSort
      this.initList()
    },
    // 切换页码操作
    async switchPaging() {
      await this.initList()
    },
    //加载表格数据
    initList(type) {
      // let month = {}
      let searchCondition = this.handleSearchCondition()
      let pagingInfo = this.$refs[this.tableRef].getPagingInfo(type)

      Object.assign(searchCondition, {
        page: pagingInfo.current_page,
        per_page: pagingInfo.page_size
      }, this.orderSortObj)

      this.loadingStatus = true

      getNonPayData(searchCondition).then(res => {
        this.loadingStatus = false
        this.dataList = res.model.data || [];
        this.pagingData.total = res.model.total || 0
      })
    },
    search() {
      if (this.$refs[this.tableRef])
        this.$refs[this.tableRef].handleCurrentChange(1)
    },
    reset() {
      this.searchCondition.name = "";
      this.search()
    },

    platformName(val) {
      let icon = {
        name: val,
        class: ''
      }
      switch (val) {
        case '微博':
          icon.class = 'icon-weibo'
          break;
        case '淘宝直播':
          icon.class = 'icon-taobaozhibo'
          break;
        case '抖音':
          icon.class = 'icon-douyin'
          break;
        case '快手':
          icon.class = 'icon-kuaishou'
          break;
        case '小红书':
          icon.class = 'icon-xiaohongshu'
          break;
        case '朋友圈':
          icon.class = 'icon-pengyouquan'
          break;
        case '美拍':
          icon.class = 'icon-meipai'
          break;
        case 'B站':
          icon.class = 'icon-bilibili'
          break;
        default:
          return icon.name
          // break;
      }
      return `
          <svg class="m-icon">
            <use xlink:href="#${icon.class}"></use>
          </svg>
          <span style="vertical-align: super;">${icon.name}</span>
        `
    },
    handleSearchCondition() {
      let condition = {}

      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_type) {
        condition.time_type = this.searchCondition.time_type
      }
      if (this.searchCondition.bool_exec) {
        condition.bool_exec = this.searchCondition.bool_exec
      }


      if (this.searchCondition.year) {
        let year = this.searchCondition.year
        let month = this.searchCondition.month
        if (month) {
          month = parseInt(month)
          let day = new Date(parseInt(year), month, 0);
          let daycount = day.getDate();//最后一天
          condition.start_time = year + '-' + (month > 9 ? month : '0' + month) + '-01'
          condition.end_time = year + '-' + (month > 9 ? month : '0' + month) + '-' + daycount
        } else {
          condition.start_time = year + '-01-01'
          condition.end_time = year + '-12-31'
        }

        //时间转成时间戳
        condition.start_time = (new Date(condition.start_time).getTime()) / 1000
        condition.end_time = (new Date(condition.end_time).getTime()) / 1000
      }

      return condition
    },
    //查看详情
    exOrderDetail(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
    // 客户联系人
    showContacts(id, sale_id, name) {
      this.contactCustomer = name
      this.dialogCustomerContactVisible = true
      getCustomerContacts({ customer_id: id, sale_id: sale_id }).then(res => {
        this.contactCustomerData = res.model || []
      });
    },
  }
}
</script>

<style scoped>
.title .i {
  background: #e03f3d;
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 5px;
}

.forms {
  margin-top: 20px;
}

.el-input-m {
  width: 80%;
}
</style>